import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { orderedIsoRange } from '@/products/leave/features/leave-calendar-utils';
import { leaveRequestRangePath } from '@/products/leave/leave-paths';

export function useLeaveRangePick() {
  const navigate = useNavigate();
  const [start, setStart] = useState<string | null>(null);

  const clear = useCallback(() => {
    setStart(null);
  }, []);

  const pick = useCallback(
    (date: string) => {
      if (!start) {
        setStart(date);
        return;
      }
      const range = orderedIsoRange(start, date);
      setStart(null);
      void navigate(leaveRequestRangePath(range.from, range.to));
    },
    [navigate, start],
  );

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        setStart(null);
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return { start, pick, clear };
}
